import api from "@/api/api-v2-config";

export async function getDepartmentListAxios() {    
    return await api.get("hrms/departments?PageNumber=1&PageSize=10000");
}

export async function deleteDepartmentAxios(id) {    
    return await api.delete("hrms/department?DepartmentId=" + id);
}

export async function postDepartmentAxios(department) {    
    return await api.post("hrms/department", department);
}

export async function putDepartmentAxios(department) {    
    return await api.put("hrms/department", department);
}

export async function getDepartmentByIDAxios(id) {    
    return await api.get("department/" + id);
}